export class CookieHelper {

  /**
   *
   * @param key
   * @param value Value to store.
   * @param maxAge Max cookie age in seconds. Defaults to one year
   * @param cookieDomain Null if current domain
   */
  public static save(key: string, value: any, maxAge: number = 31536000, cookieDomain: string | null = null): void {
    const d = new Date();
    d.setTime(d.getTime() + (maxAge * 1000));
    const expires = "expires=" + d.toUTCString();


    let cookie = key + "=" + value + ";" + expires + ";path=/";

    if (cookieDomain) {
      cookie += ';domain=' + cookieDomain;
    }

    document.cookie = cookie;
  }


  public static getCookie(key: string): string | null {
    let value: any = document.cookie.split('; ').find(row => row.startsWith(key + '='));

    if (value) {
      value = value.split('=');

      value = value ? value[1] : null;
    } else {
      value = null;
    }

    return value
  }

  public static remove(key: string) {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
